import {Injectable} from '@angular/core';
import {CookieService} from 'ngx-cookie-service';
import {environment} from '../../environments/environment';
import {Router} from '@angular/router';
import {Observable} from 'rxjs';
import {HttpClient, HttpResponse} from '@angular/common/http';
import {User} from '../models/user';
import {JwtHelperService} from '@auth0/angular-jwt';
import * as _ from 'lodash';
import {RoleEnum} from '../enums/roles';

@Injectable({
  providedIn: 'root'
})
export class AuthenticationService {

  constructor(private cookieService: CookieService, private router: Router, private httpClient: HttpClient,
              private jwtHelper: JwtHelperService) {
  }

  // function to know if user is admin
  public isAdmin(): boolean {
    const token = this.cookieService.get('token');
    return token ? _.includes(_.get(this.jwtHelper.decodeToken(token), 'roles'), RoleEnum.admin) : false;
  }

  // function to get current user
  public getUser(): User | undefined | null {
    const token = this.cookieService.get('token');
    return token ? this.jwtHelper.decodeToken(token) : undefined;
  }

  // function to remove cookies && reset global variables
  private removeCookiesAndGlobalVars() {
    this.cookieService.deleteAll(`/`);
    this.cookieService.deleteAll(`/${environment.routePath}`);
  }

  // function to log out
  public logout(): void {
    this.removeCookiesAndGlobalVars();
    this.router.navigate(['login']);
  }

  // [POST] service to log in
  public login(credentials: { [index: string]: any }): Observable<object> {
    return this.httpClient.post<HttpResponse<object>>
    (environment.api_server + environment.api_endpoints.login, credentials, {
      params: {}, withCredentials: false, observe: 'response'
    });
  }

  // [PATCH] service to update user password
  public changeUserPassword(form: { [index: string]: any }): Observable<object> {
    const newPassword: { [index: string]: any } = {
      pass: _.get(form, 'passNew')
    };
    return this.httpClient.patch<HttpResponse<object>>
    (environment.api_server + environment.api_endpoints.passwordChange, newPassword, {
      params: {}, withCredentials: false, observe: 'response'
    });
  }
}
